import { Checkbox, Col, Form, Row } from "antd";
import React, { JSX, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import styled from "styled-components";
import Swal from "sweetalert2";
import Button from "../../../components/Button/Button";
import { CardContainer } from "../../../components/Card/CardContainer";
import Input from "../../../components/Input/Input";
import TextArea from "../../../components/Input/TextArea";
import ConfirmModal from "../../../components/Modal/ConfirmModal";
import PageTitleNested from "../../../components/PageTitle/PageTitleNested";
import RolesList from "../../../components/RolesList/RolesList";
import Text from "../../../components/Text/Text";
import { roleDatasource } from "../../../datasource/RoleDatasource";
import color from "../../../resource/color";
import { profileAtom } from "../../../store/ProfileAtom";
import { defaultPropsForm } from "../../../utility/DefaultProps";
import Radio from "../../../components/Radio/Radio";
import {
  AdditionalRole,
  additionalRoleLabel,
  additionalRoleSettingLabel,
  type AdditionalRoleSetting,
} from "../../../definitions/role";
import RoleSaleApp from "../../../components/RolesList/RoleSaleApp";

interface FormData {
  rolename: string;
  roledescription?: string;
  additionalroles: AdditionalRole;
  additionalSetting: AdditionalRoleSetting;
  order: string[];
  specialRequest: string[];
  productList: string[];
  priceSpecialExclusive: string[];
  promotionSetting: string[];
  freebieList: string[];
  discountCo: {
    discountList: string[];
    manageConditionStore: string[];
    manageCondition: string[];
  };
  manageUser: {
    userList: string[];
    manageRoles: string[];
  };
  manageStore: {
    storeList: string[];
    approvePhone: string[];
  };
}
const Bottom = styled(Row)`
  border-top: 1px solid ${color.background2};
  padding-top: 16px;
  margin-top: 40px;
`;
export default function AddNewRole(): JSX.Element {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const [visibleWarning, setVisibleWarning] = React.useState(false);
  const navigate = useNavigate();
  const profile = useRecoilValue(profileAtom);
  const [menuBo, setMenuBO] = useState<Record<string, any>>({});
  const [menuSaleApp, setMenuSaleApp] = useState<Record<string, any>>({});

  const [checkedValues, setCheckedValues] = useState({
    "Website Back Office": true,
    "Sale Application": false,
  });
  const [activeKey, setActiveKey] = useState<string>("Website Back Office");
  const handleChange = (e, key) => {
    setCheckedValues((prev) => {
      const newValues = { ...prev, [key]: e.target.checked };
      return newValues;
    });
  };
  const isSaveDisabled = Object.values(checkedValues).every((value) => value === false);

  const handleClick = (key, value) => {
    setActiveKey((prevKey) => (prevKey === key ? null : key));
  };

  const onFinish = async (values: FormData) => {
    try {
      const { rolename, roledescription, additionalroles, additionalSetting } = values;
      const menus = Object.keys(menuBo).map((item) => {
        return {
          menuName: item,
          permission: menuBo[item].permission,
        };
      });
      const menusSaleApp = Object.keys(menuSaleApp).map((item) => {
        return {
          menuName: item,
          permission: menuSaleApp[item],
        };
      });
      const isBoChecked = checkedValues["Website Back Office"];
      const isSaleAppChecked = checkedValues["Sale Application"];
      const payload = {
        rolename,
        roledescription,
        additionalroles,
        additionalSetting,
        company: profile?.company,
        menus: isBoChecked ? menus : [],
        menusSaleApp: isSaleAppChecked ? menusSaleApp : [],
        updateBy: `${profile?.firstname} ${profile?.lastname}`,
        isBo: !!isBoChecked,
        isSaleApp: !!isSaleAppChecked,
      };
      try {
        setLoading(true);
        const res = await roleDatasource.createNewRole(payload);
        if (res) {
          Swal.fire({
            title: "บันทึกข้อมูลสำเร็จ",
            text: "",
            width: 250,
            icon: "success",
            timer: 2000,
            customClass: {
              title: "custom-title",
            },
            showConfirmButton: false,
          }).then(() => {
            setLoading(false);
            navigate("/UserPage/RoleManagementPage");
          });
        } else {
          Swal.fire({
            title: res.userMessage || "บันทึกข้อมูลไม่สำเร็จ",
            text: "",
            width: 250,
            icon: "error",
            customClass: {
              title: "custom-title",
            },
            showConfirmButton: false,
          }).then(() => {
            setLoading(false);
          });
        }
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const [visible, setVisible] = React.useState(false);

  return (
    <CardContainer>
      <PageTitleNested
        title='เพิ่มบทบาท'
        onBack={() => {
          const formValue = form.getFieldsValue();
          const isDirty = Object.values(formValue).some((el: any) => !!el);
          if (isDirty) {
            setVisibleWarning(true);
          } else {
            navigate(-1);
          }
        }}
      />
      <Form
        {...defaultPropsForm}
        style={{
          marginTop: 32,
        }}
        initialValues={{}}
        form={form}
        onFinish={onFinish}
      >
        <Form.Item
          label={
            <>
              ชื่อบทบาท&nbsp;<span style={{ color: "red" }}>*</span>
            </>
          }
          name='rolename'
          rules={[
            {
              required: true,
              message: "กรุณากรอกชื่อบทบาท",
            },
          ]}
        >
          <Input placeholder='ระบุชื่อบทบาท' autoComplete='off' />
        </Form.Item>
        <Form.Item
          label={
            <>
              รายละเอียดบทบาท&nbsp;<span style={{ color: "red" }}>*</span>
            </>
          }
          name='roledescription'
          style={{
            marginBottom: 0,
          }}
          className='ant-form-no-margin-bottom'
        >
          <TextArea placeholder='ระบุรายละเอียดบทบาท' maxLength={255} />
        </Form.Item>
        <br />
        <Form.Item
          label={
            <>
              การดูแลเขตการขาย&nbsp;<span style={{ color: "red" }}>*</span>
            </>
          }
          name='additionalroles'
          style={{
            marginBottom: 0,
          }}
          className='ant-form-no-margin-bottom'
          rules={[
            {
              required: true,
              message: "โปรดระบุบทบาทเสริม",
            },
          ]}
        >
          <Radio
            items={Object.entries(additionalRoleLabel).map(([key, label]) => ({
              key,
              label,
              value: key,
            }))}
          />
        </Form.Item>
        <br />
        <Form.Item
          label={
            <>
              การตั้งค่าเพิ่มเติม&nbsp;<span style={{ color: "red" }}>*</span>
            </>
          }
          name='additionalSetting'
          style={{
            marginBottom: 0,
          }}
          className='ant-form-no-margin-bottom'
          rules={[
            {
              required: true,
              message: "โปรดระบุบทบาทเสริม",
            },
          ]}
        >
          <Radio
            items={Object.entries(additionalRoleSettingLabel).map(([key, label]) => ({
              key,
              label,
              value: key,
            }))}
          />
        </Form.Item>
        <br />
        <Row style={{ padding: " 16px 0" }}>
          <Text fontWeight={700}>
            สิทธิการใช้งานแพลตฟอร์มต่างๆ&nbsp;<span style={{ color: color.error }}>*</span>
          </Text>
        </Row>
        <div style={{ display: "flex", gap: 10 }}>
          {["Website Back Office", "Sale Application"].map((key) => (
            <Checkbox
              key={key}
              onChange={(e) => {
                handleChange(e, key);
                const isChecked = e.target.checked;
                if (isChecked) {
                  setActiveKey(key);
                } else {
                  const remainingKeys = Object.entries(checkedValues)
                    .filter(([k, v]) => k !== key && v)
                    .map(([k]) => k);

                  setActiveKey(remainingKeys[0] || "");
                }
              }}
              checked={checkedValues[key]}
              style={{ marginRight: "10px" }}
            >
              {key.replace(/([A-Z])/g, " $1")}
            </Checkbox>
          ))}
        </div>
        <div style={{ display: "flex", margin: "10px 0px 20px 0px", gap: 10 }}>
          {Object.entries(checkedValues || {}).map(([key, value]) =>
            value ? (
              <Button
                onClick={() => handleClick(key, value)}
                key={key}
                typeButton={activeKey === key ? "navy-blue" : "primary-light"}
                title={key.replace(/([a-z])([A-Z])/g, "$1 $2")}
                style={{ width: "max-content" }}
              />
            ) : null,
          )}
        </div>
        {!isSaveDisabled &&
          (activeKey === "Website Back Office" ? (
            <RolesList callBack={setMenuBO} key='rolesList' initialMenu={menuBo} />
          ) : (
            <RoleSaleApp callBack={setMenuSaleApp} key='roleSaleApp' initialMenu={menuSaleApp} />
          ))}

        <Bottom>
          <Col span={22}>
            <Text color='Text3' level={6} fontFamily='Sarabun'>
              กรุณาตรวจสอบข้อมูลบทบาทที่ต้องการเพิ่มก่อนจะบันทึกทุกครั้ง
              เพื่อการใช้งานที่ดีของผู้ใช้
            </Text>
          </Col>
          <Col span={2}>
            <Button
              disabled={isSaveDisabled}
              typeButton={isSaveDisabled ? "disabled" : "primary"}
              title='บันทึก'
              onClick={() => {
                setVisible(true);
              }}
            />
          </Col>
        </Bottom>
        <ConfirmModal
          loading={loading}
          visible={visible}
          onConfirm={() => {
            form.submit();
            setVisible(false);
          }}
          onCancel={() => {
            setVisible(false);
          }}
          title='ยืนยันการบันทึกข้อมูล'
          desc='โปรดยืนยันการบันทึกข้อมูลเพิ่มบทบาท'
        />
        <ConfirmModal
          visible={visibleWarning}
          onConfirm={() => {
            setVisibleWarning(false);
            navigate(-1);
          }}
          onCancel={() => {
            setVisibleWarning(false);
          }}
          title='คุณต้องการกลับสู่หน้าหลักใช่หรือไม่'
          desc='โปรดยืนยันการกลับสู่หน้าหลัก'
        />
      </Form>
    </CardContainer>
  );
}
